import React from 'react';
import './style.css';

/**
 * LoadingSpinner component
 * Displays a loading spinner with optional text
 * @param {Object} props
 * @param {string} props.size - Size of spinner: 'small', 'medium', 'large' (default: 'medium')
 * @param {string} props.text - Optional loading text to display
 * @param {boolean} props.fullScreen - Whether to display as fullscreen overlay
 */
const LoadingSpinner = ({ size = 'medium', text, fullScreen = false }) => {
  const sizeClass = `spinner-${size}`;
  
  const spinner = (
    <div className={`loading-spinner-container ${fullScreen ? 'fullscreen' : ''}`}>
      <div className={`loading-spinner ${sizeClass}`}>
        <div className="spinner"></div>
      </div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );

  return spinner;
};

export default LoadingSpinner;
